import { observable, computed, action, makeObservable } from 'mobx';

class MainStore {
    isLoading;
    isFilterByFlagged;
    isProjectDrawerVisible;
    isFilterByEmptySP;
    isFilterByGeneralWork;
    isFilterByNotEmptySale;
    isFilterByProduct;
    isFilterByOnlyApproved;
    filterProjectIds;
    snackBarOpen;
    projectDialogOpen;
    snackBarText;
    project;
    isDoneVisible;
    isFilterByProgrammersWork;
    environmentProductDialogOpen;
    isFilterByAnalystWork;
    search;
    onSalesFilterChange;
    onProductFilterChange;
    onOnlyApprovedFilterChange;
    onProductFilterChange;
    openedEnvironmentProduct;
    projectUpdateCallback;
    productCallback;

    constructor() {
        

        this.isLoading = false;
        this.snackBarOpen = false;
        this.snackBarText = '';
        this.search = null;
        this.onSalesFilterChange = null;
        this.onProductFilterChange = null;
        this.onOnlyApprovedFilterChange = null;
        this.projectDialogOpen = false;
        this.environmentProductDialogOpen = false;
        this.project = {};
        this.openedEnvironmentProduct = {};
        this.isFilterByFlagged = localStorage.getItem('filter_flagged') === 'true';
        var projectIds = localStorage.getItem('filterProjectIds');
        if (projectIds) {
            this.filterProjectIds = JSON.parse(projectIds);
        }
        else {
            this.filterProjectIds = [];
        }
        this.isFilterByProgrammersWork = localStorage.getItem('filter_isFilterByProgrammersWork') === 'true';
        this.isFilterByAnalystWork = localStorage.getItem('filter_isFilterByAnalystWork') === 'true';
        this.isFilterByNotEmptySale = localStorage.getItem('filter_isOnlySales') === 'true';
        this.isFilterByProduct = localStorage.getItem('filter_isProduct') === 'true';
        this.isFilterByOnlyApproved = localStorage.getItem('filter_isOnlyApproved') === 'true';
        this.isFilterByEmptySP = localStorage.getItem('filter_emptySP') === 'true';
        this.isFilterByGeneralWork = localStorage.getItem('filter_generalWork') === 'true';
        this.isDoneVisible = !localStorage.getItem('filter_isDoneVisible') ? true : localStorage.getItem('filter_isDoneVisible') === 'true';
        this.projectUpdateCallback = () => { };
        this.productCallback = () => { };
        this.isProjectDrawerVisible = false;

        makeObservable(this, {
            isFilterByFlagged: observable,
            getIsFilterByFlagged: computed,
            setFilterByFlagged: action,
            isFilterByEmptySP: observable,
            getIsFilterByEmptySP: computed,
            setFilterByEmptySP: action,
            isFilterByGeneralWork: observable,
            getIsFilterByGeneralWork: computed,
            setFilterByGeneralWork: action,
            isDoneVisible: observable,
            getIsDoneVisible: computed,
            getIsFilterByNotEmptySale: computed,
            getIsFilterByOnlyApproved: computed,
            getIsFilterByProduct: computed,
            setIsDoneVisible: action,

            isFilterByProgrammersWork: observable,
            getIsFilterByProgrammersWork: computed,
            setIsFilterByProgrammersWork: action,

            isProjectDrawerVisible: observable,
            getIsProjectDrawerVisible: computed,
            setIsProjectDrawerVisible: action,

            isFilterByAnalystWork: observable,
            getIsFilterByAnalystWork: computed,
            setIsFilterByAnalystWork: action,

            filterProjectIds: observable,
            getFilterProjectIds: computed,
            uuidv4: computed,
            setFilterProjectIds: action,

            isLoading: observable,
            isFilterByNotEmptySale: observable,
            isFilterByProduct: observable,
            isFilterByOnlyApproved: observable,
            projectDialogOpen: observable,
            snackBarOpen: observable,
            snackBarText: observable,
            project: observable,
            getSnackBarText: computed,
            openedProject: computed,
            isMaskVisible: computed,
            isProjectDialogOpen: computed,
            isSnackBarOpen: computed,
            setMaskVisible: action,
            setOpenedProject: action,
            openSnackbar: action,
            closeSnackbar: action,
            setIsFilterByNotEmptySale: action,
            setIsFilterByProduct: action,
            setIsFilterByOnlyApproved: action,
            setMaskUnvisible: action,
            openProjectDialog: action,
            projectUpdateCallback: observable,
            productCallback: observable,
            closeProjectDialog: action,
            setAutorunFunction: action,
            setProductCallback: action,
            setSalesFilterChangeFunction: action,
            setOnlyApprovedFilterChangeFunction: action,
            setProductFilterChangeFunction: action,

            environmentProductDialogOpen: observable,
            openedEnvironmentProduct: observable,
            openEnvironmentProductDialog: action,
            closeEnvironmentProductDialog: action,
            isEnvironmentProductDialogOpen: computed,
            setOpenedEnvironmentProduct: action

        });
    }

    get isProjectDialogOpen() {
        return this.projectDialogOpen;
    }

    get isEnvironmentProductDialogOpen() {
        return this.environmentProductDialogOpen;
    }

    get isMaskVisible() {
        return this.isLoading;
    }

    get isSnackBarOpen() {
        return this.snackBarOpen;
    }

    get getIsFilterByFlagged() {
        return this.isFilterByFlagged;
    }

    setFilterByFlagged(value) {
        this.isFilterByFlagged = value;
        localStorage.setItem('filter_flagged', value);
    }

    get getIsFilterByEmptySP() {
        return this.isFilterByEmptySP;
    }

    setFilterByEmptySP(value) {
        this.isFilterByEmptySP = value;
        localStorage.setItem('filter_emptySP', value);
    }

    get getIsFilterByGeneralWork() {
        return this.isFilterByGeneralWork;
    }

    setFilterByGeneralWork(value) {
        this.isFilterByGeneralWork = value;
        localStorage.setItem('filter_generalWork', value);
    }

    get getIsDoneVisible() {
        return this.isDoneVisible;
    }

    setIsDoneVisible(value) {
        this.isDoneVisible = value;
        localStorage.setItem('filter_isDoneVisible', value);
    }

    get openedProject() {
        return this.project;
    }

    get getSnackBarText() {
        return this.snackBarText;
    }

    get getIsFilterByNotEmptySale() {
        return this.isFilterByNotEmptySale;
    }

    get getIsFilterByProduct() {
        return this.isFilterByProduct;
    }

    get getIsFilterByOnlyApproved() {
        return this.isFilterByOnlyApproved;
    }

    get getIsFilterByProgrammersWork() {
        return this.isFilterByProgrammersWork;
    }

    setIsFilterByNotEmptySale(value) {
        this.isFilterByNotEmptySale = value;
        localStorage.setItem('filter_isOnlySales', value);
        if (this.onSalesFilterChange) this.onSalesFilterChange();
    }

    setIsFilterByProduct() {
        let value = !this.isFilterByProduct;
        this.isFilterByProduct = value;
        localStorage.setItem('filter_isProduct', value);
        if (this.onProductFilterChange) this.onProductFilterChange();
    }

    setIsFilterByOnlyApproved() {
        let value = !this.isFilterByOnlyApproved;
        this.isFilterByOnlyApproved = value;
        localStorage.setItem('filter_isOnlyApproved', value);
        if (this.onOnlyApprovedFilterChange) this.onOnlyApprovedFilterChange();
    }
    

    setIsFilterByProgrammersWork(value) {
        this.isFilterByProgrammersWork = value;
        localStorage.setItem('filter_isFilterByProgrammersWork', value);
    }

    setOpenedProject(project) {
        this.project = project;
    }

    openSnackbar(text) {
        this.snackBarOpen = true;
        this.snackBarText = text;
    }

    closeSnackbar(text) {
        this.snackBarOpen = false;
        this.snackBarText = '';
    }

    setMaskVisible() {
        this.isLoading = true;
    }

    setMaskUnvisible() {
        this.isLoading = false;
    }

    openProjectDialog(project, updateCallback) {
        this.project = project;
        this.projectDialogOpen = true;
        this.projectUpdateCallback = updateCallback;
    }

    closeProjectDialog() {
        //this.project = {};
        this.projectDialogOpen = false;
    }

    get getIsFilterByAnalystWork() {
        return this.isFilterByAnalystWork;
    }

    setIsFilterByAnalystWork(value) {
        this.isFilterByAnalystWork = value;
        localStorage.setItem('filter_isFilterByAnalystWork', value);
    }

    get getIsProjectDrawerVisible() {
        return this.isProjectDrawerVisible;
    }

    setIsProjectDrawerVisible(value) {
        this.isProjectDrawerVisible = value;
        localStorage.setItem('isProjectDrawerVisible', value);
    }

    get getFilterProjectIds() {
        return this.filterProjectIds;
    }

    setFilterProjectIds(value) {
        this.filterProjectIds = value;
        if (this.search) this.search();
        localStorage.setItem('filterProjectIds', JSON.stringify(value));
    }

    setAutorunFunction(search) {
        this.search = search;
    }

    setProductCallback(productCallback) {
        this.productCallback = productCallback;
    }

    setSalesFilterChangeFunction(handleSalesFilterChange) {
        this.onSalesFilterChange = handleSalesFilterChange;
    }

    setProductFilterChangeFunction(handleSalesFilterChange) {
        this.onSalesFilterChange = handleSalesFilterChange;
    }

    setOnlyApprovedFilterChangeFunction(handleSalesFilterChange) {
        this.onSalesFilterChange = handleSalesFilterChange;
    }

    openEnvironmentProductDialog(environmentProduct, productCallback) {
        if (environmentProduct === null) {
            environmentProduct = { id: this.uuidv4() };
        }
        else if (environmentProduct.id === '') {
            environmentProduct.id = this.uuidv4();
        }
        this.openedEnvironmentProduct = environmentProduct;
        this.environmentProductDialogOpen = true;
        this.productCallback = productCallback;
    }

    closeEnvironmentProductDialog() {
        this.environmentProductDialogOpen = false;
    }

    setOpenedEnvironmentProduct(value) {
        this.openedEnvironmentProduct = value;
    }

    get uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

const mainStore = new MainStore();

export default mainStore;
export { MainStore };